import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

class ImgScale {

    constructor(el, i) {
        this.el = el;
        this.i = i;
        this.img = el.querySelector('img');
        if(this.img != null) {
            if (this.img.complete && this.img.naturalWidth > 0) {
                this.imgLoaded();
            } else {
                let _this = this;
                this.img.addEventListener('load', () => {
                    _this.imgLoaded();
                });
            }
        }
    }

    imgLoaded() {
        this.imgNaturalWidth = this.img.naturalWidth;
        this.imgNaturalHeight = this.img.naturalHeight;
        // add resize observer
        this.ro = new ResizeObserver(entries => {
            for (let entry of entries) {
                const cr = entry.contentRect;
                this.update(cr.width,cr.height);
            }
        });
        this.ro.observe(this.el);
    }

    update(w,h) {
        window.requestAnimationFrame(() => {
            this.img.classList.remove('transition');
            window.requestAnimationFrame(() => {
                let wrapperWidth = Math.ceil(w) + 1,
                    wrapperHeight = Math.ceil(h) + 1;
                let xFitScale = wrapperWidth / this.imgNaturalWidth,
                    yFitScale = wrapperHeight / this.imgNaturalHeight;
                let initScale = Math.max(xFitScale,yFitScale).toFixed(3),
                    hoverScale = Math.min(xFitScale,yFitScale).toFixed(3);
                this.img.style = `--init-scale:${initScale}; --hover-scale:${hoverScale}`;
                window.requestAnimationFrame(() => {
                    this.img.classList.add('transition');
                });
            });
        });
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node, i) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ImgScale(node, i);
        }
    });
}